<script>
import Template from '{Template}/Admin/Pages/Admin/Stakings/Form.template'
import AppLayout from '@/Layouts/AdminLayout'
import NavButtonLink from "@/Jetstream/NavButtonLink";
import TextInput from '@/Jetstream/TextInput'
import TextareaInput from "@/Jetstream/TextareaInput";
import LoadingButton from "@/Jetstream/LoadingButton";
import TrashedMessage from "@/Jetstream/TrashedMessage";
import SelectInput from "@/Jetstream/SelectInput";
import EmptyColumn from "@/Jetstream/EmptyColumn";

const defaultForm = {
    currency_id: null,
    allowed_days: null,
    rewards_percentage: null,
    min_amount: null,
    max_amount: null,
    status: null,
};

export default Template({
    components: {
        NavButtonLink,
        AppLayout,
        TextInput,
        TextareaInput,
        LoadingButton,
        TrashedMessage,
        SelectInput,
        EmptyColumn,
    },
    props: {
        isEdit: {
            type: Boolean,
            default: false,
        },
        errors: Object,
        staking: Object,
        currencies: Array,
    },
    remember: 'form',
    data() {
        return {
            sending: false,
            form: Object.assign({}, defaultForm),
        }
    },
    mounted() {
        if(this.isEdit) {
            this.form = this.staking;
        }
    },
    computed: {
        subTitle: function () {
            return this.isEdit ? 'Edit' : 'Create';
        },
        actionButtonTitle: function () {
            return this.isEdit ? 'Update Staking' : 'Create Staking';
        },
    },
    methods: {
        submit() {

            if(this.$page.props.mode == "readonly") {
                return this.$toast.warning('In Demo Version we enabled READ ONLY mode to protect our demo content.')
            }

            let afterRequest = {
                onStart: () => this.sending = true,
                onFinish: () => this.sending = false,
                onSuccess: () => {
                    this.$toast.open('Database Updated');
                },
                onError: () => {
                    this.$toast.error('There are some form errors');
                }
            };

            if(this.isEdit) {
                this.$inertia.put(this.route('admin.stakings.update', this.staking.id), this.form, afterRequest);
            } else {
                this.$inertia.post(this.route('admin.stakings.store'), this.form, afterRequest);
            }
        },
        destroy() {

            if(this.$page.props.mode == "readonly") {
                return this.$toast.warning('In Demo Version we enabled READ ONLY mode to protect our demo content.')
            }

            if (confirm('Are you sure you want to delete this staking?')) {
                this.$inertia.delete(this.route('admin.stakings.destroy', this.staking.id), {
                    onSuccess: () => { this.$toast.open('Staking was deleted'); },
                    onError: () => {
                        this.$toast.error('There are some form errors');
                    }
                })
            }
        },
    },
});
</script>
